import { Snapshot } from '@ember-data/store';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from 'uplisting-frontend/serializers/application';

export default ApplicationSerializer.extend(EmbeddedRecordsMixin, {
  isEmbeddedRecordsMixinCompatible: true,

  attrs: {
    price: {
      embedded: 'always',
    },
  },

  serialize(snapshot: Snapshot, options: object) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = (this as any)._super(snapshot, options);

    // BE responds with 304 when new_property is null
    // that can happen when user moves booking to a different property
    // which is done through `newProperty` relationship
    // BE responds with booking having an updated `property` relationship
    // and `new_property` not returned in the response
    // then ember data sets it to null
    // and when user tries to update any booking info - it fails with 304 status
    if (data.data.relationships?.new_property?.data === null) {
      delete data.data.relationships.new_property;
    }

    if (data.data.relationships?.new_multi_unit?.data === null) {
      delete data.data.relationships.new_multi_unit;
    }

    return data;
  },
});
